import React from 'react';
import { NavLink } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import type { useProductFilters } from '../../hooks/useProductFilters';
import { categories } from '../../data/categories';
import { capacityBuckets, priceBuckets } from '../../data/filters';
import { products } from '../../data/products';
type FilterApi = ReturnType<typeof useProductFilters>;
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <fieldset className="border-b border-line py-5 first:pt-0 last:border-0" data-id="element-592" data-mp="1qbgxh3ukqq9j">
      <legend className="mb-3 text-sm font-semibold text-ink" data-id="element-593" data-mp="1qdjl5h8987b3">{title}</legend>
      {children}
    </fieldset>;
}
function Check({
  checked,
  onChange,
  label,
  count,
  type = 'checkbox',
  name
}: {
  checked: boolean;
  onChange: () => void;
  label: string;
  count?: number;
  type?: 'checkbox' | 'radio';
  name?: string;
}) {
  return <label className="flex cursor-pointer items-center gap-2.5 py-1.5 text-sm text-ink" data-id="element-594" data-mp="292hu3l8829px">
      <input type={type} name={name} checked={checked} onChange={onChange} className="peer sr-only" data-id="element-595" data-mp="2trqqgg8asxkb" />
      <span className={`flex h-[18px] w-[18px] shrink-0 items-center justify-center border transition-colors duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-ink/30 ${type === 'radio' ? 'rounded-full' : 'rounded'} ${checked ? 'border-ink bg-ink' : 'border-ink/25 bg-white'}`} aria-hidden="true" data-id="element-596" data-mp="2otp7rwesb09d">
        {checked && <CheckIcon className="h-3 w-3 text-volt" strokeWidth={3} data-id="element-597" data-mp="3ckkvoig4dbbc" />}
      </span>
      <span className="flex-1" data-id="element-598" data-mp="37jf2kjijrm1a">{label}</span>
      {count !== undefined && <span className="text-xs text-muted" data-id="element-599" data-mp="3liepnmqevsvc">{count}</span>}
    </label>;
}
export function FilterPanel({
  api
}: {
  api: FilterApi;
}) {
  const {
    filters,
    setFilters,
    toggleBrand,
    brandOptions,
    showCapacity
  } = api;
  return <div data-id="element-600" data-mp="1r5oxb9foyrq2">
      <Section title="Categorie" data-id="element-601" data-mp="1r7hu7x0i5xkv">
        <ul className="space-y-0.5" data-id="element-602" data-mp="1n4bpitt1gegi">
          <li data-id="element-603" data-mp="1n54wnvvwt5z6">
            <NavLink to="/shop" end className={({
            isActive
          }) => `flex justify-between rounded-md px-2 py-1.5 text-sm ${isActive ? 'bg-surface font-semibold text-ink' : 'text-ink/80 hover:text-ink'}`} data-id="element-604" data-mp="1n5ms4qaqzg61">
              Alle producten <span className="text-xs text-muted" data-id="element-605" data-mp="kaofpcn2vf">{products.length}</span>
            </NavLink>
          </li>
          {categories.map(c => <li key={c.id} data-id="element-606" data-mp="4y3qvl5lxpq0">
              <NavLink to={`/shop/${c.id}`} className={({
            isActive
          }) => `flex justify-between rounded-md px-2 py-1.5 text-sm ${isActive ? 'bg-surface font-semibold text-ink' : 'text-ink/80 hover:text-ink'}`} data-id="element-607" data-mp="92l3n0djv2ra">
                {c.name}
                <span className="text-xs text-muted" data-id="element-608" data-mp="npwhj8x7eyuk">{products.filter(p => p.category === c.id).length}</span>
              </NavLink>
            </li>)}
        </ul>
      </Section>

      <Section title="Merk" data-id="element-609" data-mp="wqukroztj2c3">
        {brandOptions.map(([brand, count]) => <Check key={brand} label={brand} count={count} checked={filters.brands.includes(brand)} onChange={() => toggleBrand(brand)} data-id="element-610" data-mp="2ha6hpttprsz7" />)}
      </Section>

      <Section title="Prijs" data-id="element-611" data-mp="2da642befvlt7">
        {priceBuckets.map(b => <Check key={b.id} type="radio" name="price" label={b.label} checked={filters.price === b.id} onChange={() => setFilters(f => ({
        ...f,
        price: f.price === b.id ? null : b.id
      }))} data-id="element-612" data-mp="289rtompd7zs0" />)}
      </Section>

      {showCapacity && <Section title="Opslagcapaciteit" data-id="element-613" data-mp="2vzcnk0n24hg2">
          {capacityBuckets.map(b => <Check key={b.id} type="radio" name="capacity" label={b.label} checked={filters.capacity === b.id} onChange={() => setFilters(f => ({
        ...f,
        capacity: f.capacity === b.id ? null : b.id
      }))} data-id="element-614" data-mp="2r69vjwxxhg1z" />)}
        </Section>}

      <Section title="Beschikbaarheid" data-id="element-615" data-mp="2zffdicmq7cad">
        <Check label="Op voorraad (morgen in huis)" checked={filters.inStock} onChange={() => setFilters(f => ({
        ...f,
        inStock: !f.inStock
      }))} data-id="element-616" data-mp="2zecjvwy0qvqr" />
        <Check label="In de aanbieding" checked={filters.onSale} onChange={() => setFilters(f => ({
        ...f,
        onSale: !f.onSale
      }))} data-id="element-617" data-mp="33eo6vgdut85e" />
      </Section>
    </div>;
}